module.exports = __webpack_public_path__ + "img/tree-08-e-leaves.5667696d.png";